// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".bundle.ed7d455fbf9b95c9d66e24ac60e281766ab5d80f.js";
};